var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8572 5.85714C11.8572 6.33053 11.4734 6.71429 11 6.71429C10.5266 6.71429 10.1429 6.33053 10.1429 5.85714C10.1429 5.38376 10.5266 5 11 5C11.4734 5 11.8572 5.38376 11.8572 5.85714ZM10.3572 9.07143L10.3572 15.5C10.3572 15.855 10.645 16.1429 11 16.1429C11.355 16.1429 11.6429 15.855 11.6429 15.5L11.6429 9.07143C11.6429 8.71639 11.355 8.42857 11 8.42857C10.645 8.42857 10.3572 8.71639 10.3572 9.07143ZM0.714294 11C0.714294 5.31936 5.31937 0.714287 11 0.714287C16.6807 0.714287 21.2857 5.31936 21.2857 11C21.2857 16.6806 16.6807 21.2857 11 21.2857C5.31937 21.2857 0.714294 16.6806 0.714294 11ZM11 2C6.02945 2 2.00001 6.02944 2.00001 11C2.00001 15.9706 6.02945 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2Z",
    fill: "#49484D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.261f3052ce87cad5b83404a136dbaef6.svg";
export { ForwardRef as ReactComponent };